interface IconProps {
  className?: string;
}

export function DiceIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
    </svg>
  );
}

export function ChevronRightIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
    </svg>
  );
}

export function ChevronUpIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
    </svg>
  );
}

export function ExpandIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
    </svg>
  );
}

export function CollapseIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 9V4.5M9 9H4.5M9 9L3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5l5.25 5.25" />
    </svg>
  );
}

export function MenuIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  );
}

export function CloseIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  );
}

export function PdfIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 13h6m-6 4h4" />
    </svg>
  );
}

export function JsonIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
    </svg>
  );
}

export function SaveIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
    </svg>
  );
}

export function PlayIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );
}

export function HomeIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
    </svg>
  );
}

export function CheckIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  );
}

export function IgnusLogo({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 575.07 577.8" fill="currentColor">
      <path d="M83.07,287.15V82.31c15.84-18.03,35.83-30.55,56.17-42.8,19.38-11.68,40.36-19.59,61.63-26.53,13.31-4.34,27.27-6.82,41.08-9.68,22.69-4.69,45.31-1.19,67.82-3.21,9.34-.84,17.23,4.26,26.26,3.81,8.85-.45,16.75,4.28,25.16,5.82,27.39,5.03,51.39,18.07,75.42,30.91,19.98,10.68,38.1,24.21,55.46,40.89v150.07c23.98-9.09,35.8-16.88,43.39-28.59-4.4-3.34-9.46-1.35-14.07-1.68-4.95-.36-9.94-.08-16.32-.08v-31.89c14.4,2.34,28.28-3.44,41.27,3.89,13.18-1.53,20.67,7.42,28.73,15.7v24.05c-.97,1.03-2.21,2.21-3.29,3.51-17.72,21.32-40.92,34.97-65.44,46.78-26.92,12.97-53.63,26.43-82.35,35.18-19.64,13.87-44.92,14.11-65.01,26.91-23.3,2.34-44.54,12.55-66.95,18.35-23.81,6.16-47.82,12.25-71.57,18.94-12.86,3.62-26.57,6.15-39.89,8.78-13.55,2.68-27.75,3.67-41.04,9.13-6.69,2.75-15.54-.7-22.61,3.91-26.11-.06-51.97,6.12-78.18,3.41-13.02-1.35-24.35-6.46-32.81-16.84-7.54-9.24-8.23-19.55-.13-28.17,13.44-14.3,26.84-28.85,44.71-38.1,10.98-5.68,21.74-11.78,32.55-17.67ZM152.62,293.38c-9.42,2.72-15.88,7.09-23.56,7.7v-30.2c7.32-5.17,14.98-8.97,21.61-11.58,8.01-6.82,3.45-15.73,6.41-22.59,7-16.21,14.15-32.6,25.55-46.26,13.26-15.87,29.08-29.05,48.1-37.66,17.86-8.08,37.1-11.01,56.31-13.91,10.79-1.63,20.41,5.78,31.37,3.66,3.56-.69,6.98,2.49,10.46,3.68,21.16,7.22,41.27,16.65,56.73,33.75,2.55,2.82,4.57,6.65,10.09,7.5,18.81-6.22,39.24-9.3,59.86-11.26,1.22-1.22,2.44-2.44,4.5-4.5v-76.89c-14.47-10.68-27.99-22.45-44.54-30.33-15.89-7.57-31.78-14.92-48.47-20.55-17.06-5.76-34.73-8.54-52.46-10.82-18.46-2.37-36.88-2.58-55.5.34-17.72,2.77-35.3,5.35-52.45,11.03-16.79,5.55-32.6,12.93-48.45,20.64-16.45,8-30.07,19.42-43.13,29.4v256.11c18.67,2.43,35.24-4.11,54.04-8-6.67-16.18-11.7-32.33-16.48-49.25ZM199.13,333c19.7-.89,38.01-8.49,57.01-12.73,12.5-2.79,24.48-8.9,36.63-11.27,26.04-5.07,50.61-14.48,75.86-21.74,9-2.59,18.67-5.12,25.47-11.09,2.26-13.46-.29-25.72-4.92-36.79-8.25-19.72-18.72-38.36-38.55-49.42-16.2-9.03-32.18-18.33-51.89-16.71-7.44.61-14.97.23-22.46.06-8.38-.19-16.12,3.01-23.63,5.61-21.26,7.35-38.31,20.46-50.71,39.75-10.94,17.03-19.03,38.87-18.34,58.04.69,19.11,5.12,37.5,15.52,56.29ZM415.71,212.09c-.62.43-1.15,2.07-.75,3.77,3.71,15.65,7.51,31.29,11.27,46.84,1.28.24,2.52.88,3.39.56,9.94-3.68,19.83-7.51,29.45-11.19v-44.1c-7.72,0-16.21-2.53-21.1.59-7.45,4.76-14.43,1.17-22.27,3.54ZM83.07,325.02c-32.54,13.31-40.49,18.94-44.16,31.16h44.16v-31.16Z"/>
      <path d="M114.07,454.55c33.98,17.08,65.91,33.11,97.83,49.19,21.45,10.8,42.96,21.48,64.24,32.6,8,4.18,15.19,4.04,23.14-.02,44.67-22.83,89.44-45.45,134.21-68.08,8.56-4.32,17.26-8.35,26.58-12.85v-155.5c8.65-8.73,19.55-10.24,31-13.1v186.12c-2.63,4.68-8.49,8.02-14.37,10.93-61.19,30.25-122.46,60.33-183.68,90.5-1.92.95-2.65,3.88-5.63,3.41-48.02-24.18-96.13-48.47-144.31-72.62-14.77-7.4-29.77-14.35-44.62-21.59-5.52-2.69-10.62-6.03-14.39-11.24v-69.7c1.64-1.64,2.86-2.86,4.43-4.43h25.57v56.38Z"/>
      <path d="M417.5,315.24c1.69,4.4,2.47,8.89.29,12.99-7.42,13.88-14.2,28.01-25.42,39.7-14.37,14.96-30.44,26.81-49.26,35.67-7.05,3.32-14.3,4.54-21.4,6.77-15.56,4.9-32.19,8.19-47.83,4.52-11.24-2.63-23.52-2.12-34.11-9.38-9.64-6.61-21.94-8.98-30.76-17.5-.89-.86-3.37.25-4.63-1.82v-6.66c.63-.58,1.65-2.05,2.15-1.89,7.68,2.44,13.62-5.12,21.08-3.57,8.46-7.73,16.7-.98,24.21,1.5,4.92,1.62,10.28,2.58,15.19,5.05,3.67,1.85,9.06.64,13.64.31,12.79-.92,25.44.12,38.5-2.62,13.05-2.74,23.37-9.4,32.96-16.38,9.72-7.08,19.46-15.56,25.28-27.17,3.37-6.72,10.19-11.02,16.97-12.2,8.1-1.4,14.74-6.62,23.15-7.32Z"/>
    </svg>
  );
}
